import { AxiosError } from "axios";
import qs from "query-string";
import { useQuery } from "react-query";
import { ScreeningResponse } from "../types";
import axiosClient from "../utils/axiosClient";

export const useGetScreenings = (
  pageTable: number,
  resultsPerPage: number = 20
) => {
  const newSkip = (pageTable - 1) * resultsPerPage;
  return useQuery<any, AxiosError<any>, ScreeningResponse>(
    ["screenings", "all", pageTable],
    async () => {
      const query: Record<string, any> = {
        skip: newSkip,
        limit: resultsPerPage
      };

      const data = await axiosClient.get<ScreeningResponse>(
        `/screening/getAll?${qs.stringify(query)}`
      );
      return data.data;
    },
    {
      staleTime: Infinity,
      keepPreviousData: true,
      refetchInterval: 5000
    }
  );
};
